module.exports = __webpack_public_path__ + "img/beer_id-111.5ae802a7.png";